export default "__VITE_ASSET__688c2988__"